import { put } from 'redux-saga/effects';

// internal
import * as Action from '@app/store/typings/actions/device.d';
import { handleError } from '@app/utils/service';
import * as Service from '@app/services/device';

export function* fetchDeviceWithZone(action: Action.DeviceWithZoneFetch) {
  try {
    const { project, zone } = action.payload;
    const { data } = yield Service.fetchWithZone(project, zone, {
      limit: 5,
      offset: 0,
    });

    if (data.success) {
      yield put<Action.DeviceWithZoneSetData>({
        type: 'KEY_DEVICE_ZONE_SET_DATA',
        payload: {
          zone,
          data: data.data || [],
          meta: data.meta || {},
        },
      });
    }
  } catch (error) {
    handleError(error);
  }
}
